import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useCallback } from "react";


import "bootstrap/dist/css/bootstrap.min.css";

const GestionarActividad = () => {

  const { id } = useParams(); // id_actividad
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [entregables, setEntregables] = useState([]);
  const [nameEntregable, setNameEntregable] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // =========================
  // MENSAJES TEMPORALES
  // =========================
  useEffect(() => {
    if (!error && !success) return;
    const timer = setTimeout(() => {
      setError("");
      setSuccess("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [error, success]);

  // =========================
  // CARGAR ENTREGABLES
  // =========================
    const loadEntregables = useCallback(async () => {
    const res = await authFetch(
        `${ENDPOINTS.get_entregables}?id_actividad=${id}`
    );

    if (res.success) {
        setEntregables(res.data);
    }
    }, [authFetch, id]);

useEffect(() => {
  loadEntregables();
}, [loadEntregables]);


  // =========================
  // CREAR ENTREGABLE
  // =========================
  const handleCreateEntregable = async (e) => {
    e.preventDefault();

    if (!nameEntregable.trim()) {
      setError("Debe ingresar el nombre del entregable");
      return;
    }

    const res = await authFetch(ENDPOINTS.create_entregable, {
      method: "POST",
      body: JSON.stringify({
        id_actividad: id,
        name_entregable: nameEntregable
      })
    });

    if (!res.success) {
      setError(res.message);
      return;
    }

    setSuccess("Entregable creado correctamente");
    setNameEntregable("");
    loadEntregables();
  };

  // =========================
  // CALCULAR TOTAL PORCENTAJE
  // =========================
  const totalPorcentaje = entregables.reduce(
    (sum, e) => sum + parseFloat(e.porcentaje_base),
    0
  );

  return (
    <div className="container mt-4 p-4">

        <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
            <h3 className="mb-1">Gestionar Entregables</h3>
            <p className="text-muted mb-0">ID Actividad: {id}</p>
        </div>

        <button
            className="btn btn-outline-pink"
            onClick={() => navigate(-1)}
        >
            <i className="bi bi-arrow-left me-1"></i> Volver
        </button>
        </div>


      

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {/* ================= CREAR ENTREGABLE ================= */}
      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="mb-3">Nuevo Entregable</h5>

        <form onSubmit={handleCreateEntregable}>
          <div className="row g-3">

            <div className="col-md-9">
              <input
                className="form-control"
                placeholder="Nombre del entregable"
                value={nameEntregable}
                onChange={(e) => setNameEntregable(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <button className="btn btn-outline-pink w-100">
                Guardar Entregable
              </button>
            </div>

          </div>
        </form>
      </div>

      {/* ================= LISTA ENTREGABLES ================= */}
      <div className="card p-4 shadow-sm">

        <h5 className="mb-3">
          Entregables creados ({entregables.length})
        </h5>

        {entregables.length === 0 && (
          <div className="text-muted">
            No hay entregables creados aún.
          </div>
        )}

        {entregables.map((entregable) => (
        <div key={entregable.id} className="card p-3 mb-2">
            <div className="d-flex justify-content-between align-items-center">

            <div>
              <strong>{entregable.name_entregable}</strong>
              <div className="mt-2">

                <div className="small text-muted">
                  Base: {entregable.porcentaje_base}% | 
                  Avance mensual: {entregable.avance_mensual}%
                </div>

                <div className="fw-bold text-success">
                  Avance físico: {parseFloat(entregable.avance_fisico).toFixed(2)}%
                </div>

              </div>
            </div>

            <button
                className="btn btn-sm btn-outline-purple"
                onClick={() =>
                navigate(`/session/plan_accion/tiempo_ejecucion/${entregable.id}`)
                }
            >
                Tiempo ejecución
            </button>

            </div>
        </div>
        ))}


        <div className="mt-3 text-end">
          <strong>Entregables: {totalPorcentaje.toFixed(2)}%</strong>
        </div>

      </div>

    </div>
  );
};

export default GestionarActividad;
